import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import { filter, isNil, find, map } from "lodash";
import styled from "styled-components";

import ModalSubheader from "../../ui-building-blocks/modal/ModalSubheader";
import EventEmitter from "../../../services/event-emitter";
import { batchRequest, getRequest, postRequest } from "../../../api/ApiService";
import { logError } from "../../../services/utils";
import Loader from "react-loaders";
import NumberFormat from "react-number-format";
import {
  incrementUnacceptedDecisions,
  decrementUnacceptedDecisions
} from "../../../api/SubmitDecisions";
import WarningAlert from '../../alerts/warning';
import Fragment from "react-dot-fragment";
import ErrorInlineAlert from '../../alerts/errorInline';
import SuccessAlert from '../../alerts/success';

bootstrapUtils.addStyle(Button, "save");

const AVAILABLE_MACHINES_URL = `${process.env.REACT_APP_API_URL}static/machines/`;
const TEAM_MACHINES_URL = `${process.env.REACT_APP_API_URL}team/machines/`;
const FACTORIES_URL = `${process.env.REACT_APP_API_URL}team/factories/`;
const PRODUCT_MANUFACTURES_URL = `${process.env.REACT_APP_API_URL}team/product_manufactures/`;

const LoadingButton = styled(Button)`
  border-radius: 5px;
  width: 80px;
  padding-top: 3px;
  padding-bottom: 2px;
  float: none !important;
  text-aling: center;
  border-color: #ccc;
  border: 1px solid;
  color: #000;
  background-color: #ffb0b0;
`;
const SoldButton = styled(LoadingButton)``;
const SellButton = styled(LoadingButton)`
  color: #fff;
  background-color: #d9534f;
  :hover {
    background-color: #d9534f;
    border-color: #f00;
    color: #fff;
  }
`;
const BuyButton = styled(LoadingButton)`
  color: #fff;
  background-color: #36507e;
  :hover {
    background-color: #36507e;
    border-color: #00f;
    color: #fff;
  }
`;

class BuyingMachines extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      loading: true,
      available_machines: [],
      team_machines: [],
      loading_machines: {},
      product_manufactures: [],
      factory: 0,
      showSellConfirmation: false,
      tmp_object_id: 0,
      tmp_machine_id: 0,
      tmp_prev_round: false,
      sellError: false,
      sellConfirmationMachine: null,
      successMessage: null,
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showSuccessMessage = successMessage => {
    this.setState({
      successMessage,
    }, () => {
      this.hideSuccessMessage();
    });
  }

  hideSuccessMessage = () => {
    setTimeout(() => {
      this.setState({
        successMessage: null,
      });
    }, 5000);
  }

  componentDidMount() {
    this.eventemitter.on("show-buying-machines-modal", this.showModal);
  }

  componentWillUnmount() {
    this.eventemitter.off("show-buying-machines-modal", this.showModal);
  }

  showModal = () => {
    this.setState(
      {
        show: true
      },
      () => {
        this.fetchData();
      }
    );
  };

  hideModal = () => {
    this.setState({
      show: false
    });
  };

  showNpvModal = () => {
    this.setState(
      {
        show: false
      },
      () => {
        this.eventemitter.trigger("show-npv-modal");
      }
    );
  };

  reloadData = () => {
    const { reloadData } = this.props;
    const { loading_machines } = this.state;

    reloadData();

    getRequest(TEAM_MACHINES_URL)
      .then(res => {
        this.setState({
          team_machines: filter(
            res.body,
            machine => machine.team === this.props.teamId
          ),
          loading_machines: map(loading_machines, () => false)
        });
      })
      .catch(err => {
        logError(err, "BuyingMachines", "reloadData");
      });
  };

  fetchData = () => {
    const joinRequest = batchRequest([
      AVAILABLE_MACHINES_URL,
      TEAM_MACHINES_URL,
      FACTORIES_URL,
      PRODUCT_MANUFACTURES_URL
    ]);

    joinRequest
      .then(res => {
        if (
          res[0].statusCode !== 200 ||
          res[1].statusCode !== 200 ||
          res[2].statusCode !== 200 ||
          res[3].statusCode !== 200
        ) {
          throw res;
        }

        const available_machines = res[0].body;
        const team_machines = res[1].body;
        const factories = res[2].body;
        const factory = factories.length > 0 ? factories[0].id : 0;
        const product_manufactures = res[3].body;

        this.setState({
          available_machines,
          team_machines: filter(
            team_machines,
            machine => machine.team === this.props.teamId
          ),
          factory,
          product_manufactures,
          loading: false
        });
      })
      .catch(err => {
        logError(err, "BuyingMachines", "fetchData");
      });
  };

  haveMachine = machineId => {
    const { team_machines } = this.state;

    return !isNil(team_machines.find(i => i.machine === machineId));
  };

  isSoldMachine = machine_id => {
    return !isNil(
      find(
        this.state.team_machines,
        machine => machine.id === machine_id && machine.accepted === false
      )
    );
  };

  isLoadingMachine = machine_id => {
    const { loading_machines } = this.state;

    if (machine_id in loading_machines) {
      return loading_machines[machine_id];
    }

    return false;
  };

  createMachineRequest = machine => {
    const { factory } = this.state;

    return postRequest(`${process.env.REACT_APP_API_URL}team/machines/`).send({
      factory,
      machine
    });
  };

  onCreateMachine = machine_id => {
    const { tourMode } = this.props;

    if (tourMode === true) {
      return;
    }

    this.setState({
      loading_machines: { ...this.state.loading_machines, [machine_id]: true }
    });

    this.createMachineRequest(machine_id)
      .then(res => {
        const foundMachine = this.state.available_machines.find(i => i.id === machine_id);
        this.showSuccessMessage(`Production Line ${foundMachine.name} selected successfully`);
        incrementUnacceptedDecisions("operations");
        this.reloadData();
      })
      .catch(err => {
        logError(err, "BuyingMachines", "onCreateMachine");
      });
  };

  deleteMachineRequest = machine_id => {
    return postRequest(
      `${process.env.REACT_APP_API_URL}team/machines/${machine_id}/sell/`
    );
  };

  onDeleteMachine = machineId => {
    const { tourMode, currentRound, rounds } = this.props;
    const { team_machines, product_manufactures } = this.state;

    if (tourMode === true) {
      return;
    }

    const obj = team_machines.find(i => i.machine === machineId);
    if (!obj) {
      return;
    }

    const obj2 = product_manufactures.find(i => i.machine === obj.id);
    if (obj2) {
      this.setState({
        sellError: true,
      }, () => {
        setTimeout(() => {
          this.setState({
            sellError: false,
          });
        }, 5000);
      });
      return;
    }

    const round = rounds.find(i => i.id === obj.round);
    const is_prev_round = !!round && round.number !== currentRound;

    this.setState({
      loading_machines: { ...this.state.loading_machines, [machineId]: true }
    });

    if (is_prev_round) {
      this.setState(
        {
          tmp_object_id: obj.id,
          tmp_machine_id: machineId,
          tmp_prev_round: is_prev_round
        },
        () => {
          this.showSellConfirmation(machineId);
        }
      );
    } else {
      this.onDeleteMachineRequest(obj.id, machineId, is_prev_round);
    }
  };

  showSellConfirmation = (machineId) => {
    let sellConfirmationMachine = null;
    if (machineId) {
      const foundMachine = this.state.available_machines.find(i => i.id === machineId);
      if (foundMachine) {
        sellConfirmationMachine = foundMachine.name;
      }
    }

    this.setState({
      showSellConfirmation: true,
      sellConfirmationMachine,
    });
  };

  cancelSellConfirmation = () => {
    const { tmp_machine_id } = this.state;

    this.setState({
      showSellConfirmation: false,
      loading_machines: {
        ...this.state.loading_machines,
        [tmp_machine_id]: false
      }
    });
  };

  doSellConfirmation = () => {
    const { tmp_object_id, tmp_machine_id, tmp_prev_round } = this.state;

    this.onDeleteMachineRequest(tmp_object_id, tmp_machine_id, tmp_prev_round);
  };

  onDeleteMachineRequest = (object_id, machine_id, is_prev_round) => {
    this.deleteMachineRequest(object_id)
      .then(res => {
        const foundMachine = this.state.available_machines.find(i => i.id === machine_id);
        this.showSuccessMessage(`Production Line ${foundMachine.name} was de-selected successfully`);
        decrementUnacceptedDecisions("operations");
        this.reloadData();

        let loading_machines = { ...this.state.loading_machines };
        loading_machines[machine_id] = false;

        this.setState({
          //loading_machines,
          showSellConfirmation: false,
        });
      })
      .catch(err => {
        logError(err, "BuyingMachines", "onDeleteMachine");
      });
  };

  getBuyMachineButtonClassname = machine_id => {
    const base_classname = "btn-factory-modal btn btn-danger btn-xs";

    if (this.haveMachine(machine_id) || this.isSoldMachine(machine_id)) {
      return `${base_classname} btn-opd-step-passed`;
    }

    return base_classname;
  };

  getSellMachineButtonClassname = machine_id => {
    const base_classname = "btn-factory-modal btn btn-danger btn-xs";

    if (this.isSoldMachine(machine_id)) {
      return `${base_classname} btn-opd-step-passed`;
    }

    return base_classname;
  };

  isBuyMachineButtonDisabled = machine_id =>
    this.isLoadingMachine(machine_id) || this.haveMachine(machine_id);

  isSellMachineButtonDisabled = machine_id =>
    this.isLoadingMachine(machine_id) || !this.haveMachine(machine_id);

  soldOldMachine = machine_id => {
    const { currentRound, rounds } = this.props;
    const { team_machines } = this.state;
    const currentRoundId = find(rounds, round => round.number === currentRound)[
      "id"
    ];
    const soldMachine = find(
      team_machines,
      machine =>
        machine["sold_in_round"] === currentRoundId &&
        machine.machine === machine_id
    );

    return !isNil(soldMachine);
  };

  getButton = machineId => {
    if (this.isLoadingMachine(machineId)) {
      return <LoadingButton disabled>Loading...</LoadingButton>;
    }
    if (this.soldOldMachine(machineId)) {
      return <SoldButton disabled>Sold</SoldButton>;
    }
    if (this.haveMachine(machineId)) {
      return (
        <SellButton onClick={() => this.onDeleteMachine(machineId)}>
          Sell
        </SellButton>
      );
    }

    return (
      <BuyButton onClick={() => this.onCreateMachine(machineId)}>Buy</BuyButton>
    );
  };

  getMachineCosts = costs => {
    return `$${(costs / 1000000).toFixed(2)}M`;
  };

  render() {
    const {
      show,
      loading,
      available_machines,
      showSellConfirmation,
      sellConfirmationMachine,
      sellError,
      successMessage,
    } = this.state;
    const hideModal = this.hideModal;

    const message = <span>You won't be able to undo this decision and therefore will have to wait until next year to buy {sellConfirmationMachine} back.<br /><br />
      You will, however, receive cash equivalent to 90 to 95 % of the machine's book value (book value = machine cost - machine’s accumulated depreciation).
    </span>;

    return show ? (
      <Fragment>
        {showSellConfirmation && (
          <WarningAlert
            title="ARE YOU SURE?"
            message={message}
            onSuccess={this.doSellConfirmation}
            onCancel={this.cancelSellConfirmation}
          />
        )}
        {!showSellConfirmation && (
          <Modal
            show={true}
            onHide={hideModal}
            dialogClassName="modal-dialog-bigger"
          >
            <Modal.Header>
              <Modal.Title
                bsClass="modal-title title-light-blue"
                componentClass={ModalSubheader}
                subheader="FAB FACILITY"
              >
                Buying Machines
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {successMessage && <SuccessAlert
                message={successMessage}
              />}
              {sellError && (
                <ErrorInlineAlert
                  title="Error"
                  message="You're currently using this machine to manufacture your product(s). To sell this machine, you'll need to delete the production first."
                />
              )}
              <div className="table-responsive mt-15">
                <table className="table">
                  {loading === false && (
                    <thead>
                      <tr className="border-none">
                        <th className="text-center">
                          <b className="title-black">Production Lines</b>
                        </th>
                        <th className="text-center">
                          <b className="title-black">Units Per Hour</b>
                        </th>
                        <th className="text-center">
                          <b className="title-black">Costs</b>
                        </th>
                        <th className="text-center">
                          <b className="title-black">Action</b>
                        </th>
                        <th className="text-center" />
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {loading === true ? (
                      <tr className="border-none">
                        <td className="text-center loader-inline" colSpan="4">
                          <Loader type="ball-scale-ripple" active={true} />
                        </td>
                      </tr>
                    ) : (
                      available_machines.map((machine, i) => {
                        return (
                          <tr className="border-none" key={i}>
                            <td className="text-center">Production Line {i + 1}</td>
                            <td className="text-center">
                              <NumberFormat
                                value={machine.units_per_hour}
                                suffix=" units"
                                thousandSeparator=","
                                displayType="text"
                              />
                            </td>
                            <td className="text-center">
                              {this.getMachineCosts(machine.costs)}
                            </td>
                            <td className="text-center">
                              {this.getButton(machine.id)}
                            </td>
                            <td className="text-center" />
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
            <Modal.Footer bsClass="modal-footer op-decision-modal-footer">
              <Button bsStyle="save" onClick={hideModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Fragment>
    ) : null;
  }
}

export default BuyingMachines;



// WEBPACK FOOTER //
// ./src/components/operations/helper-components/buying-machines.js